export default {"src":"/_next/static/media/bank-linepay-mono.27bcc63c.svg","height":24,"width":83,"blurWidth":0,"blurHeight":0};